import RenderTable from './RenderTable'
import { resultsTable } from './DatasetPreview.module.css'

interface AlgorithmConstraintsValue {
  constraints?: string | string[]
  error?: string
  questionId?: string | number
}

interface Props {
  value: AlgorithmConstraintsValue
}

function AlgorithmConstraintsWidget({ value }: Props) {
  const { constraints, error, questionId } = value

  const constraintsArray =
    typeof constraints === 'string'
      ? constraints.split('\n').filter((line) => line.trim() !== '')
      : Array.isArray(constraints)
        ? constraints
        : []

  const columns = ['Constraints']
  const data = constraintsArray.map((constraint) => [constraint])

  return (
    <div className={resultsTable}>
      {error && <p style={{ color: 'red' }}>Error: {error}</p>}

      {constraintsArray.length > 0 ? (
        <div className={resultsTable}>
          <RenderTable columns={columns} data={data} />
        </div>
      ) : (
        <p>No constraints data available for question ID: {questionId}</p>
      )}
    </div>
  )
}

export default AlgorithmConstraintsWidget
